@if (isCreateDialog) {
  <h1 mat-dialog-title>Opret partner</h1>
}
@if (!isCreateDialog) {
  <h1 mat-dialog-title>Rediger partner</h1>
}
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    @if (form.value.partnerNo) {
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Partner nr.</mat-label>
          <input [value]="form.value.partnerNo" matInput disabled />
        </mat-form-field>
      </div>
    }

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Navn</mat-label>
        <input formControlName="name" matInput />
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input type="email" formControlName="email" matInput email />
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Telefon</mat-label>
        <input type="phone" formControlName="phone" matInput phone />
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Partner Gateway</mat-label>
        <mat-select formControlName="partnerGateway">
          @for (gateway of gateways; track gateway) {
            <mat-option [value]="gateway">{{ gateway | partnerGateway }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </div>

    <h2 class="form-headline margin--bottom-s">Automatiske handlinger</h2>
    <div class="flex margin--bottom-l">
      <div class="form-row">
        <mat-checkbox formControlName="createInspectionServiceOrdersAutomatically">Opret eftersyn automatisk</mat-checkbox>
      </div>
      <div class="form-row">
        <mat-checkbox formControlName="approveServiceOrdersAutomatically">Godkend ordreafregninger automatisk</mat-checkbox>
      </div>
    </div>

    <div class="form-row">
      <mat-label class="form-headline">Afregningsmodel</mat-label>
      <mat-radio-group formControlName="partnerCalculationModel">
        @for (calculationModel of calculationModels; track calculationModel) {
          <mat-radio-button [value]="calculationModel">
            {{ calculationModel | partnerCalculationModel }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
    <h2 class="form-headline margin--bottom-s">Procentsats</h2>
    <div class="flex margin--bottom-l">
      <div class="form-row">
        @if (form.controls.partnerCalculationModel.value !== partnerCalculationModelEnum.PartnerDeterminedPrice) {
          <mat-form-field
            appearance="outline"
            >
            <mat-label>Andel abonnement</mat-label>
            <input type="number" formControlName="percentageCutServiceaftale" matInput min="0" max="100" />
            <span matSuffix>%</span>
          </mat-form-field>
        }
        @if (form.controls.partnerCalculationModel.value === partnerCalculationModelEnum.PartnerDeterminedPrice) {
          <mat-form-field
            appearance="outline"
            >
            <mat-label>Andel serviceordre varer</mat-label>
            <input type="number" formControlName="percentageCutServiceordreMaterials" matInput min="0" max="100" />
            <span matSuffix>%</span>
          </mat-form-field>
        }
      </div>
    </div>
    @if (form.controls.partnerCalculationModel.value !== partnerCalculationModelEnum.PartnerDeterminedPrice) {
      <div
        class="flex margin--bottom-l"
        >
        <div class="form-row form-row--inline">
          <mat-form-field appearance="outline">
            <mat-label>Andel serviceordre timer</mat-label>
            <input type="number" formControlName="percentageCutServiceordreHours" matInput min="0" max="100" />
            <span matSuffix>%</span>
          </mat-form-field>
        </div>
        <div class="form-row form-row--inline">
          <mat-form-field appearance="outline">
            <mat-label>Andel serviceordre varer</mat-label>
            <input type="number" formControlName="percentageCutServiceordreMaterials" matInput min="0" max="100" />
            <span matSuffix>%</span>
          </mat-form-field>
        </div>
      </div>
    }
    <h2 class="form-headline margin--bottom-s">Gyldighed</h2>
    <div class="flex margin--bottom-l">
      <div class="form-row form-row--inline">
        <mat-form-field appearance="outline">
          <mat-label>Fra</mat-label>
          <mat-datepicker-toggle matPrefix [for]="validFromPicker"></mat-datepicker-toggle>
          <input #validFromInput matInput [matDatepicker]="validFromPicker" formControlName="validFrom" />
          <mat-datepicker #validFromPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-row form-row--inline">
        <mat-form-field appearance="outline">
          <mat-label>Til</mat-label>
          <mat-datepicker-toggle matPrefix [for]="validToPicker"></mat-datepicker-toggle>
          <input #validToInput matInput [matDatepicker]="validToPicker" formControlName="validTo" [min]="minValidToDate" />
          <mat-datepicker #validToPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <h2 class="form-headline margin--bottom-s">G4 aftalenumre</h2>
    <div class="flex-wrap">
      <div class="form-row flex-wrap__col--33">
        <mat-form-field appearance="outline">
          <mat-label>Olie</mat-label>
          <input type="number" formControlName="okKundeAftalenrOlie" matInput />
          @if (form.value.okKundeAftalenrOlie) {
            <mat-icon
              (click)="openPartnerInfo(form.value.okKundeAftalenrOlie)"
              matSuffix
              class="material-icons icon-click"
              >
              info
            </mat-icon>
          }
        </mat-form-field>
      </div>
      <div class="form-row flex-wrap__col--33">
        <mat-form-field appearance="outline">
          <mat-label>Gas</mat-label>
          <input type="number" formControlName="okKundeAftalenrGas" matInput />
          @if (form.value.okKundeAftalenrGas) {
            <mat-icon
              (click)="openPartnerInfo(form.value.okKundeAftalenrGas)"
              matSuffix
              class="material-icons icon-click"
              >
              info
            </mat-icon>
          }
        </mat-form-field>
      </div>
      <div class="form-row flex-wrap__col--33">
        <mat-form-field appearance="outline">
          <mat-label>Varmepumpe</mat-label>
          <input type="number" formControlName="okKundeAftalenrVarmepumpe" matInput />
          @if (form.value.okKundeAftalenrVarmepumpe) {
            <mat-icon
              (click)="openPartnerInfo(form.value.okKundeAftalenrVarmepumpe)"
              matSuffix
              class="material-icons icon-click"
              >
              info
            </mat-icon>
          }
        </mat-form-field>
      </div>
    </div>
    <h2 class="form-headline margin--bottom-s">Rapporter</h2>
    <div class="flex margin--bottom-l">
      <div class="form-row">
        <mat-checkbox formControlName="receiveDailyReport">Partner skal modtage dagsrapporter</mat-checkbox>
      </div>
      <div class="form-row">
        <mat-checkbox formControlName="receiveMonthlyReport">Partner skal modtage månedsrapporter</mat-checkbox>
      </div>
    </div>
    <h2 class="form-headline margin--bottom-s">Afregningslinier på serviceordrer</h2>
    <div class="flex margin--bottom-l">
      <div class="form-row">
        <mat-checkbox formControlName="isOrderEditingAllowed">Tillad redigering af linierne</mat-checkbox>
      </div>
    </div>
    <h2 class="form-headline margin--bottom-s">Ordreflow</h2>
    <div class="flex margin--bottom-l">
      <div class="form-row">
        <mat-checkbox formControlName="autoClosePhoneServiceOrders">Afslut telefonserviceordrer automatisk</mat-checkbox>
      </div>
    </div>
    <div class="form-row no-margin-top">
      @if (partnerInformation || fetchingPartnerInformation) {
        <mat-card appearance="outlined">
          <mat-card-title>
            <span>G4 partner information</span>
            <button class="btn-close btn-icon" (click)="hidePartnerInformation()" title="Luk">
              <mat-icon class="material-icons">close</mat-icon>
            </button>
          </mat-card-title>
          @if (!fetchingPartnerInformation && partnerInformation) {
            <mat-card-subtitle>{{ partnerInformation.name }}</mat-card-subtitle>
          }
          <mat-card-content>
            @if (fetchingPartnerInformation) {
              <mat-spinner></mat-spinner>
            }
            @if (!fetchingPartnerInformation && partnerInformation) {
              <div>
                <span>
                  Aftalenr.: {{ partnerInformation.aftalenr }}
                  <br />
                </span>
                <span>
                  Kundenr.: {{ partnerInformation.kundenr }}
                  <br />
                </span>
                @if (partnerInformation.phone) {
                  <span>
                    T: {{ partnerInformation.phone | dkPhoneNumber }}
                    <br />
                  </span>
                }
                <a href="mailto:{{ partnerInformation.email }}" class="ellipsis" title="Send mail til {{ partnerInformation.email }}">
                  {{ partnerInformation.email }}
                </a>
              </div>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>Fortryd</button>
  <button [disabled]="!form.valid" mat-raised-button color="primary" (click)="save()">Gem</button>
</div>
